<template>
    <div class="home">
        <template v-if="configuracion">
            <LoadCssComponent :estilos="configuracion.css_front"/>
        </template>

        <template v-if="manager.tipo == 1">
            <LayoutSports/>
        </template>
        <template v-if="manager.tipo == 2">
            <LayoutTeatros/>
        </template>
    </div>
</template>

<script>
    import LayoutSports from './layouts/Sports.vue';
    import LayoutTeatros from './layouts/Teatros.vue';
    import LoadCssComponent from '@/components/css/LoadCssComponent.vue';

    export default {
        head: {
            link: function() {
                return [
                    { rel: 'stylesheet', href: require('@/assets/adminlte/plugins/fontawesome-free/css/all.min.css') }
                ]
            },
            title: function() {
                return {
                    inner: 'Home',
                    complement: this.teatro?.meta_title || this.configuracion?.title || 'Teatro'
                }
            },
            meta: function() {
                return [
                    { name: 'application-name', content: this.teatro?.meta_title || this.configuracion?.title + ' - Venta Oficial de entradas' },
                    { name: 'description', content: this.teatro?.meta_description || 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos.', id: 'desc' }
                ]
            },
        },
        components: {
            LayoutSports,
            LayoutTeatros,
            LoadCssComponent
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>
